import { of } from 'rxjs';
var MockPincodeService = /** @class */ (function () {
    function MockPincodeService() {
        this.remainingAttempts = 3;
    }
    MockPincodeService.prototype.verifyPin = function (pin) {
        var _this = this;
        if (pin === '1234') {
            return of(true);
        }
        this.remainingAttempts = this.remainingAttempts - 1;
        if (this.remainingAttempts <= 0) {
            setTimeout(function () { return _this.remainingAttempts = 3; }, 60000);
        }
        return of(false);
    };
    MockPincodeService.prototype.getRemainingAttempts = function () {
        return of(this.remainingAttempts);
    };
    MockPincodeService.prototype.getSuspensionExpiration = function () {
        return of(5);
    };
    return MockPincodeService;
}());
export { MockPincodeService };
